import * as z from "zod/v4";

const GetDashboardMetricsInput_ = z.object({});

export const getDashboardMetrics = {
  name: "getDashboardMetrics" as const,
  input: GetDashboardMetricsInput_,
  output: z.object({
    promptCount: z.number(),
    responseCount: z.number(),
    sourceCount: z.number(),
  }),
};
